// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"4d3386a1","151":"7478c7a3","278":"416da333","359":"e9977e6b","680":"4212f337","896":"87cd3300"}[chunkId] + ".chunk.css";
};